import { defineAsyncComponent, AsyncComponentLoader } from "vue";

const MAX_CHUNK_LOAD_ATTEMPTS = 3;

/**
 * defineAsyncComponent wrapper that retries a failed chunk fetch (e.g. a
 * transient network blip) instead of caching the rejection and rendering
 * nothing on every subsequent open.
 */
export function lazyComponent(loader: AsyncComponentLoader) {
	return defineAsyncComponent({
		loader,
		onError(error, retry, fail, attempts) {
			if (attempts <= MAX_CHUNK_LOAD_ATTEMPTS) {
				retry();
			} else {
				console.error("Failed to load component chunk after", attempts, "attempts:", error);
				fail();
			}
		},
	});
}
